<template>
  <div class="bm-team-info" v-cloak >
    <div class="team" >
      <div>
        <img v-if="teams.badge" :src="formatterImgSrc(teams.badge)" >
        <img v-else src="@/assets/images/team-logo-empty.png" />
      </div>
      <div>
        <p>{{ teams.name }}</p>
        <span>{{ teams.location }}</span>
      </div>
       <div @click="routerTeamEdit" >
         <span>编辑</span>
       </div>
    </div>

    <!-- 教练 start -->
    <div class="title">
      球队官员（{{ officer.length }}人）
      <span @click="routerTeamOfficer()" >添加</span>
    </div>
    <div class="list" v-if="officer.length > 0" >
      <van-swipe-cell v-for="(item) in officer" :key="item.id" :right-width="48">
        <div class="team player" @click="routerTeamOfficer(item.id)" >
          <div>
            <img class="thumb" v-if="item.avatar || item.photo" :src="formatterImgSrc(item.avatar || item.photo)">
            <img class="thumb" v-else src="@/assets/images/player-logo-empty.png" />
          </div>
          <div>
            <p>{{item.name}}</p>
            <span>{{item.role}}</span>
          </div>
          <div>
            <span>{{ item.desc }}</span>
          </div>
        </div>
        <span slot="right" class="remove" @click="removeOfficer(item.id)">删除</span>
      </van-swipe-cell>
      <div style="width: 100%; height: 20px;" ></div>
    </div>
    <!-- 教练 end -->

    <div class="title" >
      参赛球员（{{ playerStatus.length }}人）
      <span class="addPlayer" @click="routerAddPlayer" >添加</span>
    </div>
    <!--
    <div class="team player" @click="routerPlayerEdit(item.id)" v-for="(item, index) in playerStatus" :key="item.id" >
      <div>
        <img class="thumb" v-if="item.avatar || item.photo" :src="formatterImgSrc(item.avatar || item.photo)">
        <img class="thumb" v-else src="@/assets/images/player-logo-empty.png" />
      </div>
      <div>
        <p>{{ item.trueName }}</p>
         <span v-if="item.number" >{{item.number}}号</span>
      </div>
      <div>
        <span>{{ item.desc }}</span> &lt;!&ndash; 禁赛状态 api 暂未提供 所以暂不实现 &ndash;&gt;
      </div>
    </div>
    -->
    <van-swipe-cell :right-width="48" v-for="(item) in playerStatus" :key="item.id" >
      <div class="team player" @click="routerPlayerEdit(item.id)">
        <div>
          <img class="thumb" v-if="item.avatar || item.photo" :src="formatterImgSrc(item.avatar || item.photo)">
          <img class="thumb" v-else src="@/assets/images/player-logo-empty.png" />
        </div>
        <div>
          <p>{{ item.trueName }}</p>
          <span v-if="item.number" >{{item.number}}号</span>
        </div>
        <div>
          <span>{{ item.desc }}</span>  <!-- 禁赛状态 api 暂未提供 所以暂不实现 -->
        </div>
      </div>
      <van-button
        square
        slot="right"
        type="danger"
        text="删除"
        class="remove"
        @click="removePlayer(item.id)"
      />
    </van-swipe-cell>
  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat } from '@/utils/'
import { getBMPlayerList, getBMTeamPlayerList, deleteBMPlayer, getBMMatchTeamOfficerList, matchOrganizationDeleteTeamOfficer } from '@/api/team'
import { Cell, CellGroup, Button, Toast, SwipeCell, Dialog } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(SwipeCell).use(Dialog)

export default {
  name: 'TeamInfo',
  data() {
    return {
      query: this.$route.query,
      teams: {},
      teamId: null,
      matchId: null,
      playerList: [],
      playerStatus: [],
      officer: []
    }
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  created() {
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    if (!this.matchId || !this.teamId) {
      Toast('参数错误')
      return
    }
    // this.getBMPlayerList()
    this.getBMTeamPlayerList()
    this.getBMMatchTeamOfficerList()
  },
  methods: {
    routerTeamOfficer(officerId) {
      this.$router.push({
        path: '/player/officer-edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId,
          officerId: officerId
        }
      })
    },
    removeOfficer (officerId) {
      Dialog.confirm({
        title: '操作',
        message: '确认删除该官员'
      }).then(() => {
        // on confirm
        const params = {
          officerId: officerId,
          matchId: this.matchId,
          teamId: this.teamId
        }
        matchOrganizationDeleteTeamOfficer(params).then(response => {
          Toast('删除官员成功')
          this.getBMMatchTeamOfficerList()
        })
      }).catch(() => {
        // on cancel
      })
    },
    getBMMatchTeamOfficerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMMatchTeamOfficerList(params).then(response => {
        const data = response.data
        this.officer = data.officer
      })
    },
    routerAddPlayer() {
      this.$router.push({name: 'PlayerEdit',
        query: {matchId: this.matchId, teamId: this.teamId, type: 'match'}})
    },
    routerTeamEdit: function() {
      this.$router.push({
        path: '/participate/team-edit',
        query: {
          teamId: this.teamId,
          matchId: this.matchId
        }
      })
    },
    routerPlayerEdit: function(playerId) {
      this.$router.push({
        path: '/player/edit',
        query: {
          playerId: playerId,
          teamId: this.teamId,
          matchId: this.matchId
        }
      })
    },
    getBMPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMPlayerList(params).then((response) => {
        let data = response.data
        this.teams = data.team
        this.playerList = data.players
      })
    },
    getBMTeamPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamPlayerList(params).then(response => {
        let data = response.data
        this.teams = data.team
        this.playerStatus = data.players
      })
    },
    removePlayer (playerId) {
      // console.log(clickPosition, instance)
      Dialog.confirm({
        title: '操作',
        message: '确认删除该球员'}).then(() => {
        // on confirm
        const params = {
          playerId: playerId,
          matchId: this.matchId,
          teamId: this.teamId
        }
        deleteBMPlayer(params).then(response => {
          Toast('删除球员成功')
          this.getBMTeamPlayerList()
        })
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>

<style lang="stylus">
.bm-team-info
  background-color white
  .title
    font-size: 18px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
    .addPlayer
      border-radius: 14px;
      border: 1px solid #f2f2f2;
      float: right;
      font-size: 12px;
      font-weight: 400;
      color: #9b9b9b;
      padding: 3px 13px;
  .team
    display flex
    padding 15px
    div:first-child
      text-align center
      width 52px
      height 40px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:nth-child(2)
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 112px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
    div:last-child
      width: 50px
      span
        text-align center
        border-radius:14px;
        border:1px solid rgba(242,242,242,1);
        font-size: 12px;
        font-weight: 400;
        color: rgba(155,155,155,1);
        height: auto;
        padding: 3px 0px;
        display block
  .title
    font-size:18px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(0,0,0,1);
    padding: 10px 15px;
    span
      border-radius:14px;
      border:1px solid rgba(242,242,242,1);
      float: right
      font-size:12px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(155,155,155,1);
      padding: 3px 13px;
  .player
    position relative
    padding: 10px 15px;
    div:last-child
      display flex
      justify-content center
      align-items: center;
      span
        border: none
        color: #EC4E4E
    div:first-child
      .thumb
        width: 40px
        height: 40px
        border-radius: 50%;
  .player::before
    content "";
    position absolute
    height: 1px
    width calc(100% - 30px)
    background-color #F2F2F2
    bottom: 0
  [v-cloak] {
    display: none;
  }
  .remove {
    background-color: #ec4e4e;
    width: 48px;
    height: 100%;
    font-size: 12px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/team-info.vue